export default __webpack_public_path__ + "static/media/W5-1200F_frontal_LED.a78d9c4f.png";